import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('CustomerFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getFilteredCustomerList: function (filterOptions) {
            return $http.put(settings.ApiURL + settings.CustomerURL + "/filter", filterOptions);
        },
        getCustomerById: function (id, position) {
            return $http.get(settings.ApiURL + settings.CustomerURL + "/" + id + "/" + position);
        },
        getBillingCustomers: function (filterOptions) {
            return $http.put(settings.ApiURL + settings.CustomerURL + "/billingcustomer",filterOptions);
        },
        getNewCustomer: function () {
            return $http.get(settings.ApiURL + settings.CustomerURL + "/newcustomer");
        },
        saveCustomer: function (customer, originalId, originalPos) {
            return $http.put(settings.ApiURL + settings.CustomerURL + "/" + originalId + "/" + originalPos, customer);
        },
        saveCustomerType: function (customerType) {
            return $http.put(settings.ApiURL + settings.MasterDataURL + "/customertypes", customerType);
        },
        deleteCustomer: function (id, position) {
            return $http.delete(settings.ApiURL + settings.CustomerURL + "/" + id + "/" + position);
        },
        getCountryList: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/countries/0");
        },
        getPaymentTermList: function (companyId) {
            if (companyId == null) companyId = 0;
            return $http.get(settings.ApiURL + settings.PaymentTermsURL + "/paymentterms/" + companyId + "/1");
        },
        getSpecialPriceGroupList: function () {
            return $http.get(settings.ApiURL + settings.SpecialPriceGroupURL + "/1");
        },
        getCustomerSpecialPriceList: function (id) {
            return $http.get(settings.ApiURL + settings.SpecialPricesURL + "/bycustomer/" + id);
        },
        getCustomerSpecialPriceById: function (id) {
            return $http.get(settings.ApiURL + settings.SpecialPricesURL + "/" + id);
        },
        getLanguageList: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/languages/0");
        },
        getCustomerTypeList: function () {
            return $http.get(settings.ApiURL + settings.MasterDataURL + "/customertypes/0");
        },
        getUnloadPointList: function () {
            return $http.get(settings.ApiURL + settings.UnloadPointURL);
        },
        getProductList: function (groupId) {
            return $http.get(settings.ApiURL + settings.ProductURL + "/withgroupspecialprices/" + groupId);
        },
        getProductDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/dropdown/0");
        },
        getUnloadPointById: function (id, customerId, position) {
            return $http.get(settings.ApiURL + settings.UnloadPointURL + "/" + id + "/" + customerId + "/" + position);
        },
        getLastDeliveryLocationById: function (customerId, position) {
            return $http.get(settings.ApiURL + settings.UnloadPointURL + "/lastDeliveryLocation/" + customerId + "/" + position);
        },
        getBillQuantityTypeList: function () {
            return $http.get(settings.ApiURL + settings.CustomerURL + "/GetBillQuantityTypeList");
        },
        getAutoEmailOptionsList: function () {
            return $http.get(settings.ApiURL + settings.CustomerURL + "/GetAutoEmailOptionsList");
        },
        getSignatureSettingsOptionList: function () {
            return $http.get(settings.ApiURL + settings.CustomerURL + "/SignatureSettingsOptionList");
        },
        getProductOptions: function () {
            return $http.get(settings.ApiURL + settings.CustomerURL + "/ProductOptions");
        },
        getPrintOptions: function () {
            return $http.get(settings.ApiURL + settings.CustomerURL + "/PrintOptions");
        },
        getStrappingChartProfile: function(){
            return $http.get(settings.ApiURL + settings.StrappingChartProfilesURL + "/list");
        },
        getDippingType: function(){
            return $http.get(settings.ApiURL + settings.UnloadPointURL + "/getUnloadPointDippingTypes");
        }
    };
}]);

app.controller('CustomerController', ['$q', '$scope', 'CustomerFactory', 'CompanyFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal','ProductFactory',
    function ($q, $scope, CustomerFactory, CompanyFactory, $rootScope, settings, masterFactory, $uibModal,ProductFactory) {
        $rootScope.pageTitle = "Customers";
        $scope.customerList = [];
        $scope.customer = {};
        $scope.billingCustomerList = [];
        $scope.CustomerPositionList = [];
        $scope.companies = [];
        $scope.nonPrintCompanies = [];
        $scope.deletedUnloadPoints = [];
        $scope.deletedSpecialPriceProducts = [];
        $scope.signatureSettingsOptions = [];
        $scope.printOptions = [];
        $scope.productOptions = [];

        $scope.priceGroupText = "";
        $scope.error = "";
        $scope.modelState = [];
        $scope.isFormVisible = false;
        $scope.deletMessage = 'Are you sure you want to delete?';
        $scope.originalId = 0;
        $scope.originalPos = 0;
        $scope.popupVisible = false;
        $scope.productDropdown = [];
        $scope.PageSize = 20;
        $scope.TotalCount = null;
        $scope.strappingChartProfileDropdown = [];
        $scope.lastDeliveryLocation = [];
        $scope.dippingTypes = [];
        $scope.filterOptions = {
            CustomerNo: null, CustomerName: null, CustomerAddress: null,
            GridPagerOptions: { PageIndex: 0, PageSize: 20, TotalPages: null }
      };

        $scope.popupOptionsUnloadPointGrid = {
            width: 350,
            height: 150,
            fullScreen: false,
            shading: true,
            showTitle: true,
            dragEnabled: false,
            closeOnOutsideClick: true,
            bindingOptions: {
                visible: 'popupVisible',
            }
        };
        $scope.defaultItem = {Id:null, ProfileId:"Select"};
        $scope.defaultDippingType = {id:null, name:"Default"};

      var customerGridDataSource = {
        store: new DevExpress.data.CustomStore({
                // DataSource Configuration
                key: ["Id", "Position"],
                pageSize: $scope.PageSize,
                // Data Access Logic
                load: function (loadOptions) {
                    var d = $.Deferred();
                    var params = {};

                    if (loadOptions != undefined) {
                        $scope.filterOptions.CustomerName = null;
                        $scope.filterOptions.CustomerAddress = null;
                        $scope.filterOptions.CustomerNo = null;
                        if (loadOptions.filter != undefined) { // accessing grid filter values                         
                            for (var i = 0; i < loadOptions.filter.length; i++) {
                                if (loadOptions.filter[i].length == 3) {
                                    if (loadOptions.filter[i][0] == "FullName") $scope.filterOptions.CustomerName = loadOptions.filter[i][2];
                                    else if (loadOptions.filter[i][0] == "Address") $scope.filterOptions.CustomerAddress = loadOptions.filter[i][2];
                                    else if (loadOptions.filter[i][0] == "Number") $scope.filterOptions.CustomerNo = loadOptions.filter[i][2];
                                }
                            }
                        }
                        $scope.filterOptions.GridPagerOptions.PageSize = (IsUndefinedOrNull(loadOptions.take) == true) ? $scope.PageSize : loadOptions.take;
                        $scope.filterOptions.GridPagerOptions.PageIndex = ((IsUndefinedOrNull(loadOptions.take) && IsUndefinedOrNull(loadOptions.skip)) == true) ? 0 : (loadOptions.skip / loadOptions.take);
                    }
                    CustomerFactory.getFilteredCustomerList($scope.filterOptions).success(function (data) {
                        d.resolve(data.CustomerListVM, { totalCount: data.TotalCount });
                        $scope.TotalCount = data.TotalCount;
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                    });
                    return d.promise();
                },
                byKey: function (key, extra) {
                },
                update: function (values) {
                }
            })
        };

        // Grid renderers
        $scope.refreshGrid = function (PageIndex, Key) {
            $scope.originalId = 0;
            $scope.originalPos = 0;
            $scope.error = '';
            $('#gridCustomer').dxDataGrid({
                columns: [
                    { caption: 'Customer No', dataField: 'Number', cssClass: 'Number', alignment: 'center', dataType: 'string', width: 100 },
                    {
                        caption: 'Customer Name', dataField: 'FullName', cssClass: 'FullName', dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<span />')
                                .text(options.data.Name1)
                                .append("</br>")
                                .appendTo(container);
                            container.addClass('grid-cell-align-left');
                            $('<span />')
                                .text(options.data.Name2)
                                .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    },
                    {
                        caption: 'Customer Address', dataField: 'Address', cssClass: 'Address', dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            var addressLine2 = "";
                            if (options.data.PostcodeString != null) addressLine2 = addressLine2 + options.data.PostcodeString + " ";
                            if (options.data.City != null) addressLine2 = addressLine2 + options.data.City + " ";
                            if (options.data.District != null) addressLine2 = addressLine2 + options.data.District + " ";
                            if (options.data.State != null) addressLine2 = addressLine2 + options.data.State;
                            $('<span />')
                                .text(options.data.Address)
                                .append("</br>")
                                .appendTo(container);
                            container.addClass('grid-cell-align-left');
                            $('<span />')
                                .text(addressLine2)
                                .append("</br>")
                                .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    }
                ],
                contentReadyAction: grdReadyAction,
              dataSource: customerGridDataSource,
                filterRow: { visible: true },
                groupPanel: { visible: false },
                noDataText: "No Customers Found",
                paging: { pageSize: $scope.PageSize, pageIndex: PageIndex },
                pager: { visible: true, allowedPageSizes: [10, 20, 30], showPageSizeSelector: true },
                rowAlternationEnabled: false,
                selection: { mode: 'single' },
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData[0] != null) {
                        $scope.getCustomer(selectedRowsInfo.selectedRowsData[0].Id,selectedRowsInfo.selectedRowsData[0].Position);                      
                    }
                },
                scrolling: { mode: 'standard' },
                showBorders: true,
                showColumnLines: true,
                showRowLines: false,
                sorting: { mode: 'none' },
                wordWrapEnabled: true
            });

            if (Key != null && Key > 0) {
                var dataGrid = $('#gridCustomer').dxDataGrid('instance');
                (dataGrid as unknown as FacnmDx).selectRows([Key]);
            }
        };

        $scope.viewBillingCustomerModal = function () {
            $uibModal.open({
                  templateUrl: 'app-legacy/Entities/templates/defaultCustomerModel.html',
                  controller: 'BillingCustomerController',
                  size: 'lg',
                  scope: $scope,
                  windowTemplateUrl: 'app-legacy/Entities/templates/modal-scrollable-content.html'
              });
      };

        $scope.viewProductList = function () {
            $uibModal.open({
                templateUrl: 'app-legacy/Entities/templates/defaultCustomerModel.html',
                controller: 'ProductListController',
                size: 'lg',
                scope: $scope,
                windowTemplateUrl: 'app-legacy/Entities/templates/modal-scrollable-content.html'
            }).result.then(function () {
                $scope.unloadPoint.ProductId = $rootScope.user.ProductId;
                $scope.unloadPoint.ProductName = $rootScope.user.ProductName;
                $scope.onUnloadPointChange();
            }).catch(function () {
            });
            $scope.unloadPointId = $scope.unloadPoint.Id;
        };

        $scope.isCompanyIdInArray = function (companies, id) {
            for (var i = 0; i < companies.length; i++) {
                if (companies[i].Id == id) {
                    return true;
                }
            }
            return false;
        }

        $scope.refreshUnloadPointGrid = function () {
            $scope.isUnloadPointSelected = false;
            $scope.deletedUnloadPoints = [];
            $('#gridUnloadPoint').dxDataGrid({
                dataSource: {
                    store: {
                        data: $scope.customer.UnloadPoints,
                        type: 'array',
                        key: 'Id'
                    }
                },
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                rowAlternationEnabled: false,
                columnAutoWidth: true,
                height: 230,
                selection: { mode: 'single' },
                editing: {
                    editEnabled: false,
                    insertEnabled: false
                },
                paging: {
                    pageSize: 10
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [10, 20, 30]
                },
                filterRow: {
                    visible: false
                },
                groupPanel: {
                    visible: false
                },
                columns: [
                    {
                        caption: 'Unload Point',
                        dataField: 'Id',
                        dataType: 'number',
                        alignment: 'center'
                    },
                    {
                        caption: 'Tank Number',
                        dataField: 'TankNumber',
                        dataType: 'string',
                        alignment: 'center'
                    },
                    {
                        width: 100,
                        alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<a/>').addClass('dx-link')
                                .text('Delete')
                                .on('dxclick', function () {
                                    if ($scope.customer.UnloadPoints.length > 1) {
                                        $("#gridUnloadPoint").dxDataGrid("instance").removeRow(options.rowIndex);
                                        $scope.deletedUnloadPoints.push(options.data);
                                    }
                                    else {
                                        $scope.popupVisible = true;
                                    }
                                })
                                .appendTo(container);
                        }
                    }
                ],
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData.length > 0 && !selectedRowsInfo.selectedRowsData[0].Changed) {
                        //$('#loadingModal').modal({ backdrop: 'static' });
                        CustomerFactory.getUnloadPointById(selectedRowsInfo.selectedRowsData[0].Id, $scope.customer.Id, $scope.customer.Position).success(function (data) {
                            $scope.unloadPoint = data;
                            $scope.isUnloadPointSelected = true;
                            $scope.isIdenticalToCustomer = $scope.unloadPoint.Name1 == null;
                            if(data.CustomerPos != data.LastDeliveryCustomerPos && data.LastDeliveryCustomerPos > 0)
                            {
                                CustomerFactory.getLastDeliveryLocationById(data.CustomerId, data.LastDeliveryCustomerPos).success(function (data){
                                    $scope.lastDeliveryLocation = data
                                }).error(function (data, status) {
                                    masterFactory.setError(status, data, $scope);
                                }).finally(function () {
                                 $('#loadingModal').modal('hide');
                                });
                            }
                            else{
                                $scope.lastDeliveryLocation = [];
                            }
                            if ($scope.unloadPoint.ProductId) {
                                ProductFactory.getProductDetails($scope.unloadPoint.ProductId).success(function (data) {
                                    $scope.unloadPoint.ProductName = data.ShortProductName;
                                }).error(function (data, status) {
                                    masterFactory.setError(status, data, $scope);
                                });
                            }
                            
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                            $scope.isUnloadPointSelected = false;
                        }).finally(function () {
                            //$('#loadingModal').modal('hide');
                        });
                    }
                    else if (selectedRowsInfo.selectedRowsData.length > 0 && selectedRowsInfo.selectedRowsData[0].Changed) {
                        $scope.unloadPoint = selectedRowsInfo.selectedRowsData[0];
                        $scope.isUnloadPointSelected = true;
                        $scope.isIdenticalToCustomer = $scope.unloadPoint.Name1 == null;
                        $rootScope.user.ProductId = 0;
                        $rootScope.user.ProductName= '';
                    }
                    else {
                        $scope.unloadPoint = {};
                        $scope.isUnloadPointSelected = false;
                    }
                }
            });
        };

        $scope.refreshDeliveryCustomerGrid = function () {
            $('#gridDeliveryCustomer').dxDataGrid({
                dataSource: $scope.customer.DeliveryCustomers,
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                rowAlternationEnabled: false,
                height: 230,
                selection: { mode: 'single' },
                paging: {
                    pageSize: 10
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [10, 20, 30]
                },
                filterRow: {
                    visible: true
                },
                groupPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: 'Number',
                        dataField: 'Number',
                        cssClass: 'Number',
                        dataType: 'string',
                        alignment: 'center'
                    },
                    {
                        caption: 'Name',
                        dataField: 'Name1',
                        cssClass: 'Name1',
                        dataType: 'string',
                        alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<span />').text(options.data.Name1).appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    }
                ],
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData.length > 0) {
                        var selectedDeliveryCustomer = selectedRowsInfo.selectedRowsData[0];
                        var dataGrid = $('#gridCustomer').dxDataGrid('instance');

                        dataGrid.clearSelection();
                        (dataGrid as unknown as FacnmDx).selectRows(selectedRowsInfo.selectedRowsData[0]);
                    }
                }
            });
        };

        $scope.refreshSpecialPriceGrid = function () {
            $('#gridSpecialPrice').dxDataGrid({
                dataSource: $scope.customer.SpecialPriceProducts,
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                rowAlternationEnabled: false,
                height: 230,
                selection: { mode: 'single' },
                paging: {
                    pageSize: 10
                },
                editing: {
                    editEnabled: false,
                    insertEnabled: true,
                    removeEnabled: true
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [10, 20, 30]
                },
                columns: [
                    {
                        caption: 'Product',
                        alignment: 'center',
                        cellTemplate: function (container, options) {
                            container.addClass('grid-cell-align-left');
                            if (options.data.ProductName != undefined && options.data.ProductId != undefined && options.data.Price != undefined) {
                                var span = document.createElement("span");
                                var t = document.createTextNode(options.data.ProductName);
                                span.appendChild(t);
                                container.get(0).appendChild(span);
                            }
                            else {
                                var div = document.createElement("div");
                                container.get(0).appendChild(div);
                                $(div).dxSelectBox({
                                    dataSource: $scope.productList,
                                    valueExpr: 'Id',
                                    displayExpr: 'ProductName',
                                    value: options.value,
                                    valueChangeAction: function (e) {
                                        options.data.ProductName = $scope.filter($scope.productList, e.value).ProductName;
                                        options.data.ProductId = e.value;
                                        var product = $scope.filter($scope.productList, e.value);
                                        var groupPrices = (product != null && product.GroupSpecialPrices != null && product.GroupSpecialPrices.length > 0) ? product.GroupSpecialPrices : null;
                                        if (groupPrices != null) {

                                            var rows = "<table>";
                                            groupPrices.forEach(function (row) {
                                                rows = rows + "<tr><td><strong>> " + row.MinimumQty + " " + product.QuantityUnit + ":</strong></td><td>" + row.Price + "/ " + product.PricePer + " " + product.QuantityUnit + "</td></tr>";
                                            });
                                            rows = rows + "</table>";
                                            var tag = document.getElementById('newTag');
                                            $(tag).attr('data-content', rows).data('bs.popover');

                                            $('#imgFlag').css('background-color', '#111111').css('cursor', 'pointer').attr('onClick', 'showGroupPrices( )');
                                        }
                                        else {
                                            $('#imgFlag').css('background-color', '#999999').css('cursor', 'default').attr('onClick', '');
                                        }
                                    }
                                });
                            }
                        }
                    },
                    {
                        width: 100,
                        caption: 'Special Price',
                        dataField: 'Price',
                        dataType: 'number',
                        alignment: 'center',
                        showEditorAlways: true
                    },
                    {
                        width: 80,
                        caption: 'Discount',
                        dataField: 'Discount',
                        dataType: 'number',
                        alignment: 'center',
                        showEditorAlways: true,
                        calculateCellValue: function (rowData) {
                            if (rowData['Discount'] == 0) {
                                return '';
                            }
                            else return rowData['Discount'];
                        }
                    },
                    {
                        width: 40,
                        alignment: 'center',
                        headerCellTemplate: function (container, options) {
                            container.width(30);
                        },
                        cellTemplate: function (container, options) {
                            container.width(30);
                            var product = options.data.ProductId != undefined ? $scope.filter($scope.productList, options.data.ProductId) : null;
                            var groupPrices = (product != null && product.GroupSpecialPrices != null && product.GroupSpecialPrices.length > 0) ? product.GroupSpecialPrices : null;
                            if (groupPrices != null) {

                                var rows = "<div><table>";
                                groupPrices.forEach(function (row) {
                                    rows = rows + "<tr><td><strong> " + row.MinimumQty + " " + product.QuantityUnit + ":</strong></td><td>" + row.Price + "/ " + product.PricePer + " " + product.QuantityUnit + "</td></tr>";
                                });
                                rows = rows + "</table></div>";

                                $('<a id=Popover' + options.data.ProductId + ' href="#" data-original-title="<strong>Price group information</strong>" data-html="true" data-toggle="popover" data-trigger="hover click" data-placement="bottom" data-content="'
                                    + rows + '" onClick="showGroupPrices(Popover' + options.data.ProductId + ')" "> <img style="background-color:#111111;" src="assets/Content/Images/Icons/pricegroup-info-disable.png"  /> </a>')
                                    .appendTo(container);
                            }
                            else if (options.data != null && options.data.ProductId == undefined) {
                                $('<a href="#" id="newTag" data-original-title="<strong>Price group information</strong>" data-html="true" data-toggle="popover" ' +
                                    ' data-placement="left" data-content=""> <img id="imgFlag" style="background-color:#999999;" src="assets/Content/Images/Icons/pricegroup-info-disable.png" /> </a>')
                                    .appendTo(container);
                            }
                            else {
                                $('<img style="background-color:#999999;" src="assets/Content/Images/Icons/pricegroup-info-disable.png"  />')
                                    .appendTo(container);
                            }

                        }
                    }
                ],
                rowInserted: function (e) {
                    var dataGrid = $('#gridSpecialPrice').dxDataGrid('instance');
                    var index = $scope.customer.SpecialPriceProducts.length - 1;
                    if (e.data.Price.toString().indexOf(',') > 0) e.data.Price = e.data.Price.toString().replace(/,/g, '.');

                    $scope.customer.SpecialPriceProducts[index].Changed = true;
                    $scope.customer.SpecialPriceProducts[index].Price = e.data.Price;
                    $scope.customer.SpecialPriceProducts[index].CustomerId = $scope.customer.Id != undefined ? $scope.customer.Id : 0;
                    $scope.customer.SpecialPriceProducts[index].CustomerPosition = $scope.customer.Position;
                    $scope.specialPrice = $scope.customer.SpecialPriceProducts[index];

                    dataGrid.refresh();
                    (dataGrid as unknown as FacnmDx).selectRows($scope.specialPrice);
                },
                rowRemoved: function (e) {
                    var index = $scope.customer.SpecialPriceProducts.indexOf(e.data);
                    e.data.Deleted = true;
                    e.data.Changed = true;
                    $scope.deletedSpecialPriceProducts.push(e.data);
                }
            }).dxDataGrid('instance');
            var grd = document.getElementById("gridSpecialPrice");
            if (grd.getElementsByClassName("dx-datagrid-header-panel")[0].childNodes.length == 1)
                $('<span > Customer Specific Price </span>').appendTo(grd.getElementsByClassName("dx-datagrid-header-panel")[0]);

        };

        $scope.getNewCustomer = function () {
            CustomerFactory.getNewCustomer().success(function (data) {
                $scope.customer = data;
                //$scope.customer.Position = -1;
                $scope.customer.SpecialPriceProducts = [];
                $scope.customer.UnloadPoints = [];
                $scope.customer.DeliveryCustomers = [];
                $rootScope.user.DefaultCustomerId = data.Id;
                $rootScope.user.DefaultCustomerName = data.DefaultCustomerName;
                $scope.originalId = 0;
                $scope.originalPos = 0;
                $scope.isUnloadPointVisible = false;
                $scope.refreshUnloadPointGrid();
                $scope.refreshSpecialPriceGrid();
                $scope.refreshDeliveryCustomerGrid();

            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        };

        // Button click functions and submit form function
        $scope.addNewEntity = function () {
            $rootScope.pageTitle = "New Customer";
            $scope.isFormVisible = true;
            $scope.isDeleteVisible = false;
            $scope.getNewCustomer();

            ToggleGreenToYellow();
        };

        $scope.confirmDeleteEntity = function () {
            $scope.deletMessage = 'Are you sure you want to delete?';
            $('#DeleteModal').modal({ backdrop: 'static' });
        };

        $scope.deleteEntity = function (value) {
            $scope.error = '';
            if (value == 0) {
                $('#DeleteModal').modal('hide');
            }
            else if (value == 1) {
                if ($scope.customer.Position == 1 && $scope.customer.DeliveryCustomers.length > 0 && $scope.deletMessage == 'Are you sure you want to delete?') {
                    $scope.deletMessage = 'Related delivery customers will also be Deleted !';
                }
                else {
                    CustomerFactory.deleteCustomer($scope.customer.Id, $scope.customer.Position).success(function (data) {
                        var dataGrid = $('#gridCustomer').dxDataGrid('instance');
                        var pageIndex = dataGrid.pageIndex();
                        $scope.PageSize = dataGrid.pageSize();
                        $scope.cancelForm();
                        $scope.refreshGrid(pageIndex, null);
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Customer successfully' });
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#DeleteModal').modal('hide');
                    });
                }
            }
        };

        $scope.cancelForm = function () {
            var dataGrid = $('#gridCustomer').dxDataGrid('instance');
            dataGrid.clearSelection();
            $scope.isFormVisible = false;
            $scope.customerForm.submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
        };

        $scope.reset = function (type) {
            if (type == 'update') { // get db bankaccount and set to scope.bankaccount.
                $('#loadingModal').modal({ backdrop: 'static' });
                CustomerFactory.getCustomerById($scope.customer.Id, $scope.customer.Position).success(function (data) {
                    $scope.customer = data;
                    $rootScope.user.DefaultCustomerId = data.Id;
                    $rootScope.user.DefaultCustomerName = data.DefaultCustomerName;
                    $scope.refreshUnloadPointGrid();
                    $scope.refreshSpecialPriceGrid();
                    $scope.refreshDeliveryCustomerGrid();
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                    $scope.error = '';
                });
            }
            else {
                $scope.addNewEntity();
            }
            $scope.customerForm.$setPristine();
            $scope.customerForm.submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Customer details were reset' });
        };

        $scope.validateEmails = function () {
            var emailstr = $scope.customer.ContactEmail.replace(/\s/g, "");
            if (emailstr.length > 0) {
                var emails = emailstr.split(/,|;/);
                var Email_Regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                if (emails && emails.length > 0) {
                    for (var i = 0; i < emails.length; i++) {
                        if (!Email_Regex.test(emails[i])) {
                            $scope.customerForm.ContactEmail.$setValidity('email', false);
                            return;
                        }
                    }
                }
            }
            $scope.customerForm.ContactEmail.$setValidity('email', true);
        };

        $scope.submitForm = function () {
            var companyId = $scope.nonPrintCompanies.filter(a => a.Id == $scope.customer.CompanyId)
            if(companyId.length == 0){
                $scope.customer.CompanyId = null;
            }
            $scope.error = '';
            if ($scope.customerForm.$valid) {
                $scope.saveEntity();
                $scope.customerForm.submitted = false;
            } else {
                $scope.customerForm.submitted = true;
            }
        };

        $scope.saveEntity = function () {
            var id = -1;
            $scope.customer.UnloadPoints.forEach(function (unloadPoint) {
                if (unloadPoint.CustomerId == null && unloadPoint.CustomerPos == null) {
                    unloadPoint.CustomerId = $scope.customer.Id;
                    unloadPoint.CustomerPos = $scope.customer.Position;
                    unloadPoint.Id = id;
                    id--;
                }
            });
            $scope.customer.Id = $rootScope.user.DefaultCustomerId;

            $('#loadingModal').modal({ backdrop: 'static' });
            CustomerFactory.saveCustomer($scope.customer, $scope.originalId, $scope.originalPos).success(function (data) {
                $scope.closeModelStateErrors();
                $scope.modifiedCustomer = '';
                $scope.error = '';
                $scope.originalId = data;
                $scope.originalPos = $scope.customer.Position;
                $scope.getCustomer($scope.originalId, $scope.originalPos);
                var dataGrid = $('#gridCustomer').dxDataGrid('instance');
                var pageIndex = dataGrid.pageIndex();
                var keys = dataGrid.getSelectedRowKeys();
                $scope.pageSize = dataGrid.pageSize();
                if ($scope.customer.Id > 0) {
                    if ($scope.customer.Id != $scope.originalId || $scope.customer.Position != $scope.originalPos) {
                        $scope.modifiedCustomer = $scope.customer.Number;
                        $scope.cancelForm();
                    }
                    $scope.refreshGrid(pageIndex, keys);
                }
                else {
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex, keys);
                }
                if ($scope.customer.Id > 0) {
                    if ($scope.modifiedCustomer != '') {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Associated Customers (' + $scope.modifiedCustomer + ') successfully ' });
                        $scope.modifiedCustomer = '';
                    }
                    else {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Customer successfully' });
                    }
                }
                else {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Customer successfully' });
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        // New Unload point + icon click function
        $scope.addNewUnloadPoint = function () {
            var dataGrid = $('#gridUnloadPoint').dxDataGrid('instance');
            var len = 0;
            var id = 1;
            if ($scope.customer.UnloadPoints != null)
                len = $scope.customer.UnloadPoints.length;
            if (len > 0) {
                $scope.customer.UnloadPoints.forEach(function (unloadPoint) {
                    if (unloadPoint.Id >= id)
                        id = unloadPoint.Id + 1;
                });
            }
            $scope.unloadPoint = {};
            $scope.unloadPoint.Id = id;
            $scope.unloadPoint.Deleted = false
            $scope.unloadPoint.Changed = true;
            $scope.customer.UnloadPoints[len] = $scope.unloadPoint;

            dataGrid.refresh();
            (dataGrid as unknown as FacnmDx).selectRows($scope.unloadPoint);
        };

        // New Customer type button click function
        $scope.addnewCustomerType = function () {
            $('#customerTypeModal').modal({ backdrop: 'static' });
            CustomerFactory.saveCustomerType($scope.customerType).success(function (data) {
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Added new Customer Type' });
                //DevExpress.ui.notify("Added new Customer Type", "success", settings.ToastDuration);

                CustomerFactory.getCustomerTypeList().success(function (data) {
                    $scope.customerTypes = data;
                    $('#customerTypeModal').modal('hide');
                }).error(function (data, status) {
                    masterFactory.setError(status, 'Error on loading Customer Types: ' + data, $scope);
                });
            }).error(function (data) {
                $scope.modelError = data;
            }).finally(function () {

            });
        };

        $scope.onBillingCustomerChange = function () {
            if ($scope.originalId != 0)
                $scope.customer.Number = '';
        };

        $scope.onCustomerTypeChange = function () {
            if ($scope.originalId != 0)
                $scope.customer.Number = '';
            if ($scope.customer.Position == 0) {
                //var index = -1;
                //for (var i = 0; i < $scope.billingCustomerList.length; i++) {
                //    if ($scope.billingCustomerList[i].Id == $scope.customer.Id)
                //        index = i;
                //}
                //$scope.billingCustomerList.splice(index, 1);
                $scope.customer.Id = $scope.billingCustomerList[0].Id
            }
        };

        $scope.closeCustomerType = function () {
            $scope.customerType = null;
            $scope.modelError = '';
            $('#customerTypeModal').modal('hide');
        };

        $scope.closeModelAlert = function () {
            $scope.modelError = '';
        };

        // Helping functions and events
        $(window).resize(function () {
            onWindowResize('#gridCustomer', settings.GridMarginHeight);
        });

        function grdReadyAction(e) {
            onWindowResize('#gridCustomer', settings.GridMarginHeight);
        };

        collapsibleHeaderClickEvent($scope);

        $scope.closeAlert = function () {
            $scope.error = null;
        };

        $scope.closeModelStateErrors = function () {
            $scope.modelState = [];
        };

        $scope.clickHalfDiv = function (control) {
            masterFactory.setFocus(control);
        };

        $scope.filter = function (input, id) {
            var i = 0, len = input.length;
            for (; i < len; i++) {
                if (+input[i].Id == +id) {
                    return input[i];
                }
            }
            return null;
        };

        $scope.onCompanyChange = function () {
            CustomerFactory.getPaymentTermList($scope.customer.CompanyId).success(function (data) {
                $scope.paymentTerms = data;
            }).error(function (data, status) {
                masterFactory.setError(status, 'Error on loading Payment Terms: ' + data, $scope);
            });
        };

        $scope.onUnloadPointChange = function () {
            var dataGrid = $('#gridUnloadPoint').dxDataGrid('instance');
            var selectedKey = dataGrid.getSelectedRowKeys();
            var selectedRows = dataGrid.getSelectedRowsData();
            var index = $scope.customer.UnloadPoints.indexOf(selectedRows[0]);

            $scope.unloadPoint.Changed = true;
            $scope.customer.UnloadPoints[index] = $scope.unloadPoint;
            dataGrid.refresh();
            (dataGrid as unknown as FacnmDx).selectRows(selectedKey, true);
        };

        $scope.chartProfileDropDown = function(profile){
            if(profile.Id==null)
                return profile.ProfileId;
            else
                return profile.ProfileId+' - '+profile.ProfileDescription;
        }
        
        $scope.onPriceGroupChange = function () {
            if ($scope.customer.PriceGroupId != null && $scope.customer.PriceGroupId != undefined && $scope.customer.PriceGroupId > 0) {
                $('#loadingModal').modal({ backdrop: 'static' });
                CustomerFactory.getProductList($scope.customer.PriceGroupId).success(function (data) {
                    $scope.productList = data;
                    $scope.refreshSpecialPriceGrid();
                }).error(function (data, status) {
                    masterFactory.setError(status, 'Error on loading Products: ' + data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
        };
        $scope.getCustomer = function(Id,Position) {
            $('#loadingModal').modal({ backdrop: 'static' });
            CustomerFactory.getCustomerById(Id, Position).success(function (data) {
                $scope.error = '';
                if (!$scope.isCompanyIdInArray($scope.companies, data.CompanyId)) {
                    data.CompanyId = null;
                    $scope.error = "Invalid Company is detected."
                }
                $rootScope.user.DefaultCustomerId = data.Id;
                $rootScope.user.DefaultCustomerName = data.DefaultCustomerName;
                $scope.customer = data;
                $scope.originalId = $scope.customer.Id;
                $scope.originalPos = $scope.customer.Position;
                if ($scope.customer.PriceGroupId != null && $scope.customer.PriceGroupId != 0) {
                    CustomerFactory.getProductList($scope.customer.PriceGroupId).success(function (data) {
                        $scope.productList = data;
                        $scope.refreshSpecialPriceGrid();
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    });
                }
                else {
                    $scope.productList = $scope.generalProductList;
                    $scope.refreshSpecialPriceGrid();
                }

                CustomerFactory.getPaymentTermList($scope.customer.CompanyId).success(function (data) {
                    $scope.paymentTerms = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.refreshUnloadPointGrid();
                $scope.refreshDeliveryCustomerGrid();
                $scope.isFormVisible = true;
                $scope.isDeleteVisible = true;
                ToggleYellowToGreen();
                $rootScope.pageTitle = "Customers";
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        }

        $('#customerTypeModal').on('hidden.bs.modal', function () {
            $scope.customerType = {};
            $scope.modelError = '';
        });

        $('body').on('click', function (e) {
            if ($(e.target).parents('[data-toggle="popover"]').length === 0) {
                $('[data-toggle="popover"]').popover('hide');
            }
        });

        function showGroupPrices(popoverid) {
            $(popoverid).popover();
        }

        // Initialization - this runs on load
        var init = function () {
            masterFactory.verifyAuthentication();

            $('#loadingModal').modal({ backdrop: 'static' });
            $q.all([
                CustomerFactory.getCountryList().success(function (data) {
                    $scope.countries = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                masterFactory.getCompanies(0).success(function (data) {
                    $scope.companies = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getSpecialPriceGroupList().success(function (data) {
                    $scope.specialPriceGroups = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getLanguageList().success(function (data) {
                    $scope.languages = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getCustomerTypeList().success(function (data) {
                    $scope.customerTypes = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getProductList(0).success(function (data) {
                    $scope.generalProductList = data;
                    $scope.productList = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getProductDropdown(0).success(function (data) {
                    $scope.productDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CompanyFactory.getNonPrintCompanyList(0).success(function (data) {
                    $scope.nonPrintCompanies = data;
                }).error(function (data) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getBillQuantityTypeList().success(function (data) {
                    $scope.billQuantityTypeList = data;
                }).error(function (data) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getAutoEmailOptionsList().success(function (data) {
                    $scope.autoEmailOptionsList = data;
                }).error(function (data) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getSignatureSettingsOptionList().success(function (data) {
                    $scope.signatureSettingsOptions = data.filter(function (s) { return s.name != 'None' });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getProductOptions().success(function (data) {
                    $scope.productOptions = data.filter(function (s) { return s.name != 'None' });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getPrintOptions().success(function (data) {
                    $scope.printOptions = data.filter(function (s) { return s.name != 'None' });
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getStrappingChartProfile().success(function (data) {
                    $scope.strappingChartProfileDropdown = data;
                    $scope.strappingChartProfileDropdown.splice(0,0,$scope.defaultItem);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CustomerFactory.getDippingType().success(function(data){
                    $scope.dippingTypes = data;
                    $scope.dippingTypes.splice(0,0,$scope.defaultDippingType);
                }).error(function (data, status){
                    masterFactory.setError(status, data, $scope);
                }),
            ]).then(function () {
                $scope.refreshGrid(0, null);
                $('#loadingModal').modal('hide');
            });
        };

        init();

  }]);

  app.controller('ProductListController',['$q', '$scope', 'settings', 'masterFactory', '$uibModalInstance', '$rootScope','ProductFactory',
      function ($q, $scope, settings, masterFactory, $uibModalInstance, $rootScope, ProductFactory) {
          $scope.filterOptions = {
              ProductNumber: null, ProductName: null, ProductGroup: null,QuantityUnit: null,ProductTypeId:null,
              GridPagerOptions: { PageIndex: 0, PageSize: 20, TotalPages: null }
          };
          $scope.TotalCount = null;
          $scope.ProductGridDataSource = [];
          $scope.BillingCustomerName = [];
          $scope.TitleName = "Product";

          $scope.loadGridDataSource = function () {
              var dataSource = {
                  store: new DevExpress.data.CustomStore({
                      // DataSource Configuration
                      key: ["Id"],
                      pageSize: $scope.PageSize,
                      // Data Access Logic
                      load: function (loadOptions) {
                          var d = $.Deferred();
                          var params = {};

                          if (loadOptions != undefined) {
                              $scope.filterOptions.ProductNumber = null;
                              $scope.filterOptions.ProductName = null;
                              $scope.filterOptions.ProductGroup = null;
                              $scope.filterOptions.QuantityUnit = null;
                              $scope.filterOptions.ProductTypeId = null;
                              if (loadOptions.filter != undefined) { // accessing grid filter values 
                                    for (var i = 0; i < loadOptions.filter.length; i++) {
                                      if (loadOptions.filter[i].length == 3) {
                                          if (loadOptions.filter[i][0] == "ProductNumber") $scope.filterOptions.ProductNumber = loadOptions.filter[i][2];
                                          else if (loadOptions.filter[i][0] == "ShortProductName") $scope.filterOptions.ProductName = loadOptions.filter[i][2];
                                          else if (loadOptions.filter[i][0] == "ProductCategoryId") $scope.filterOptions.ProductGroup = loadOptions.filter[i][2];
                                          else if (loadOptions.filter[i][0] == "QuantityUnit") $scope.filterOptions.QuantityUnit = loadOptions.filter[i][2];
                                          else if (loadOptions.filter[i][0] == "ProductTypeId") $scope.filterOptions.ProductTypeId = loadOptions.filter[i][2];
                                      }
                                  }
                              }
                              $scope.filterOptions.GridPagerOptions.PageSize = (IsUndefinedOrNull(loadOptions.take) == true) ? $scope.PageSize : loadOptions.take;
                              $scope.filterOptions.GridPagerOptions.PageIndex = ((IsUndefinedOrNull(loadOptions.take) && IsUndefinedOrNull(loadOptions.skip)) == true) ? 0 : (loadOptions.skip / loadOptions.take);
                          }
                          ProductFactory.getFilteredProductList($scope.filterOptions).success(function (data) {
                              d.resolve(data.ProductListVM, { totalCount: data.TotalCount });
                              $scope.TotalCount = data.TotalCount;
                          }).error(function (data, status) {
                              masterFactory.setError(status, data, $scope);
                          }).finally(function () {
                          });
                          return d.promise();
                      },
                      byKey: function (key, extra) {
                      },
                      update: function (values) {
                      }
                  })
              };
              return dataSource;
          }

          // Grid renderers
          $scope.refreshGrid = function (PageIndex, Key) {
              $('#gridProduct').dxDataGrid({
                  columns: [
                      { caption: 'Product Number', dataField: 'ProductNumber', cssClass: 'ProductNumber', dataType: 'string', alignment: 'center', width: 150 },
                      {
                          caption: 'Product Name', dataField: 'ShortProductName', cssClass: 'ShortProductName', dataType: 'string', alignment: 'center',
                          cellTemplate: function (container, options) {
                              $('<span />')
                                  .text(options.data.ShortProductName)
                                  .appendTo(container);
                              container.addClass('grid-cell-align-left');
                          }
                      },
                      { caption: 'UOM', dataField: 'QuantityUnit', cssClass: 'QuantityUnit', dataType: 'string', alignment: 'center', width: 150 },
                      {
                          caption: 'Product Category', dataField: 'ProductCategoryId', cssClass: 'ProductCategoryId', dataType: 'number', alignment: 'center',
                          lookup: {
                              dataSource: $scope.ProductCategories,
                              displayExpr: 'Name',
                              valueExpr: 'Id'
                          }
                      },
                      {
                          caption: 'Product Type', dataField: 'ProductTypeId', cssClass: 'ProductTypeId', dataType: 'number', alignment: 'center',
                          lookup: {
                              dataSource: $scope.productTypes,
                              displayExpr: 'Name',
                              valueExpr: 'Id'
                          }
                      }
                  ],
                  contentReadyAction: grdReadyAction,
                  dataSource: $scope.loadGridDataSource(),
                  filterRow: { visible: true },
                  groupPanel: { visible: false },
                  noDataText: "No Products Found",
                  paging: { pageSize: $scope.PageSize, pageIndex: PageIndex },
                  pager: { visible: true, allowedPageSizes: [10, 20, 30], showPageSizeSelector: true },
                  rowAlternationEnabled: false,
                  selection: { mode: 'single' },
                  selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData[0] != null) {
                        $scope.saveSelection(selectedRowsInfo);
                    }
                 },
                  scrolling: { mode: 'standard' },
                  showBorders: true,
                  showColumnLines: true,
                  showRowLines: false,
                  sorting: { mode: 'none' }
              });
              if (Key != null && Key > 0) {
                var dataGrid = $('#gridProduct').dxDataGrid('instance');
                (dataGrid as unknown as FacnmDx).selectRows([Key]);
            }
            };

          function grdReadyAction(e) {
              onWindowResize('#gridProduct', settings.GridMarginHeight);
          };

          $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
          };

          $scope.saveSelection = function (selectedRowsInfo) {
              if (!selectedRowsInfo) {
                  $rootScope.user.ProductId = $scope.TempProductId != null ? $scope.TempProductId : $rootScope.user.ProductId;
                  $rootScope.user.ProductName = $scope.TempProductName != null ? $scope.TempProductName : $rootScope.user.ProductName;
                  
                  $uibModalInstance.close();
              }
              else {
                  $scope.TempProductId = selectedRowsInfo.selectedRowsData[0].Id;
                  $scope.TempProductName = selectedRowsInfo.selectedRowsData[0].ShortProductName;
              }
          }

          collapsibleHeaderClickEvent($scope);

          $('body').on('click', function (e) {
              if ($(e.target).parents('[data-toggle="popover"]').length === 0) {
                  $('[data-toggle="popover"]').popover('hide');
              }
          });


          // Initialization - this runs on load
          var init = function () {
              masterFactory.verifyAuthentication();

              $('#loadingModal').modal({ backdrop: 'static' });
              $q.all([
                  ProductFactory.getProductCategoryList().success(function (data) {
                      $scope.ProductCategories = data;
                  }).error(function (data, status) {
                      masterFactory.setError(status, data, $scope);
                  }),
                  ProductFactory.getProductTypeDropdown().success(function (data) {
                      $scope.productTypes = data;
                  }).error(function (data, status) {
                      masterFactory.setError(status, data, $scope);
                  }),
                  ProductFactory.getFilteredProductList($scope.filterOptions).success(function (data) {
                      $scope.ProductGridDataSource = data;
                  }).error(function (data, status) {
                      masterFactory.setError(status, data, $scope);
                  })
              ]).then(function () {
                  $scope.refreshGrid(0, null);
                  $('#loadingModal').modal('hide');
              });
          };

          init();

}]);

